module.exports = __webpack_public_path__ + "static/img/hsx11.0088d4cb.png";